import GetFieldComponent from "./FieldFabric";

export default GetFieldComponent;
